module.exports = __webpack_public_path__ + "img/uv.35378773.png";